import { useGenerateIds } from '#public_ts/composables';

import type { IdRef } from './injection';

export type { IdRef };

export function useGenerateIdRef() {
    const generateIds = useGenerateIds();
    return (_id?: string): IdRef => {
        const id = _id ?? generateIds();
        return {
            id,
            tabid: `${id}--tab`,
            btnid: `${id}--btn`,
        };
    };
}
